import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppstateService } from './appstate/appstate.service';
import { ProfileMasterDetailsComponent } from './components/profile-master-details/profile-master-details.component';
import { SharedModule } from "../shared/shared.module";
import { MaterialModule } from '../shared/material/material.module';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';


@NgModule({
  declarations: [
    ProfileMasterDetailsComponent,
    ProfileDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule
],
  providers: [
    AppstateService,
  ],
  exports: [
    ProfileMasterDetailsComponent,
    ProfileDetailsComponent
  ]
})
export class CoreModule { }
